<nav class="navbar navbar-dark bg-dark mb-3">
  <a class="navbar-brand" href="#">
    <img src="https://caplin.dgp.unam.mx/CMPCA/pluginfile.php/1105/mod_page/content/11/signupsign_inscribirs_2798.png" width="30" height="30" class="d-inline-block align-top" alt="">
    Inscripciones en Linea
  </a>
</nav>
